import React from 'react';
import { TESTIMONIALS } from '../../data/mock';
import { Card, CardContent } from '../ui/card';
import { MapPin } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
            What installers say
          </h2>
          <p className="mt-4 text-lg text-[#475569]">
            Real feedback from installers across Metro Melbourne
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="mt-10 grid md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((testimonial) => (
            <Card key={testimonial.id} className="card-hover border-[#E2E8F0]">
              <CardContent className="pt-8 pb-6">
                <div className="testimonial-card">
                  <p className="text-[#475569] leading-relaxed text-lg">
                    "{testimonial.quote}"
                  </p>
                </div>
                <div className="mt-6 pt-6 border-t border-[#E2E8F0]">
                  <p className="font-semibold text-[#111111]">
                    {testimonial.author}
                  </p>
                  <p className="mt-1 text-sm text-[#64748B] flex items-center gap-1">
                    <MapPin className="w-3 h-3" />
                    {testimonial.location}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
